import {
  IApplicationState,
  IThunkContext,
  TThunkDispatch,
  IGetPublicationParams,
  IGetPublicationSuccessPayload,
} from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { actionTypes } from '../../constants/actionTypes';

import {
  IGetArticleResponse200,
  IGetArticleResponse400,
  fetchGetArticle,
} from '../../repositories/valuation-b2b/v1/get-article';

const {
  GET_PUBLICATION_REQUEST: REQUEST,
  GET_PUBLICATION_SUCCESS: SUCCESS,
  GET_PUBLICATION_FAILURE: FAILURE,
} = actionTypes;

const requestAction = actionGenerator<typeof REQUEST>(REQUEST);
const successAction = actionGenerator<typeof SUCCESS, IGetPublicationSuccessPayload>(SUCCESS);
const failureAction = actionGenerator<typeof FAILURE>(FAILURE);

export const getPublication = ({ articleId }: IGetPublicationParams) => (
  dispatch: TThunkDispatch,
  getState: () => IApplicationState,
  context: IThunkContext,
) => {
  const state = getState();
  const { articles } = state.publications;

  if (articleId in articles) {
    return Promise.resolve();
  }

  dispatch(requestAction());

  return fetchGetArticle<IGetArticleResponse200, IGetArticleResponse400>({
    httpApi: context.httpApi,
    parameters: { articleId },
  })
    .then(response => {
      if (response.statusCode === 200) {
        dispatch(
          successAction({
            data: response.response,
            articleId,
          }),
        );
      } else {
        dispatch(failureAction());
      }
    })
    .catch(error => {
      if (context.logger) {
        context.logger.error(error, { message: 'Browser error /v1/get-article/' });
      }

      dispatch(failureAction());
    });
};
